<ion-content>
  <div class="content-wrapper">
    <uoa-header size="large" logo-type="horizontal" logo-position="start"></uoa-header>
    <h1 class="aria-element-hidden">University of Auckland Events</h1>

    <section class="search-filter-bar" *ngIf="allEvents != undefined">
      <div>
        <h2 class="aria-element-hidden">Search and Filter Events</h2>

        <uoa-search-autocomplete
          placeholder="Search for events"
          search-button="true"
          [searchValue]="lastSearchBy"
          filter-button="true"
          [searchFiltersList]="filter"
          options="[]"
          (filteredArray)="applyFilters($event.detail)"
          (searchedText)="searchEvents($event.detail)"
        ></uoa-search-autocomplete>
      </div>
    </section>

    <section *ngIf="isMobile() && allEvents != undefined">
      <ion-label class="sort-label pad-left">Sort events by</ion-label>
      <ion-item class="sort mobile">
        <ion-select [(ngModel)]="selectedSortBy" (ionChange)="sortEvents()" value="startDateTime,asc" interface="popover">
          <ion-select-option value="startDateTime,asc">Date</ion-select-option>
          <ion-select-option value="lowestPrice,desc">Price: High to Low</ion-select-option>
          <ion-select-option value="lowestPrice,asc">Price: Low to High</ion-select-option>
          <ion-select-option value="name,asc">Name: A-Z</ion-select-option>
          <ion-select-option value="name,desc">Name: Z-A</ion-select-option>
        </ion-select>
      </ion-item>
    </section>

    <section class="breadcrumbs-container">
      <ion-breadcrumbs class="breadcrumbs" *ngIf="isMobile()">
        <ion-breadcrumb>
          <ion-button
            id="home-trigger-button"
            (click)="openBreadcrumb()"
            [ngClass]="{'button-clicked': buttonClicked, 'default-button': !buttonClicked}"
          >
            <ion-icon name="ellipsis-horizontal"></ion-icon>
          </ion-button>
          <ion-popover
            trigger="home-trigger-button"
            showBackdrop="false"
            arrow="false"
            alignment="start"
            (ionPopoverWillDismiss)="closeBreadcrumb()"
          >
            <ng-template>
              <ion-item href="https://www.auckland.ac.nz" class="custom-popover">Home</ion-item>
              <ion-item href="https://www.auckland.ac.nz/news" class="custom-popover">News and events</ion-item>
            </ng-template>
          </ion-popover>
        </ion-breadcrumb>
        <ion-breadcrumb href="/"> University events </ion-breadcrumb>
      </ion-breadcrumbs>
      <ion-breadcrumbs class="breadcrumbs" *ngIf="!isMobile()">
        <ion-breadcrumb href="https://www.auckland.ac.nz"> Home </ion-breadcrumb>
        <ion-breadcrumb href="https://www.auckland.ac.nz/news"> News and events </ion-breadcrumb>
        <ion-breadcrumb href="/"> University events </ion-breadcrumb>
      </ion-breadcrumbs>
    </section>

    <section class="event-header-container" *ngIf="allEvents != undefined">
      <div class="events-title">
        <h1>University events</h1>
      </div>
      <ion-item class="sort" *ngIf="!isMobile()">
        <ion-label class="sort-label">Sort events by</ion-label>
        <ion-select [(ngModel)]="selectedSortBy" (ionChange)="sortEvents()" value="startDateTime,asc" interface="popover">
          <ion-select-option value="startDateTime,asc">Date</ion-select-option>
          <ion-select-option value="lowestPrice,desc">Price: High to Low</ion-select-option>
          <ion-select-option value="lowestPrice,asc">Price: Low to High</ion-select-option>
          <ion-select-option value="name,asc">Name: A-Z</ion-select-option>
          <ion-select-option value="name,desc">Name: Z-A</ion-select-option>
        </ion-select>
      </ion-item>
    </section>

    <section>
      <h2 class="aria-element-hidden">Events</h2>

      <app-loading-indicator *ngIf="allEvents == undefined"></app-loading-indicator>

      <app-event-card-grid
        *ngIf="allEvents != undefined && displayEvents.length > 0"
        [events]="displayEvents | slice:0:displayCount"
      ></app-event-card-grid>

      <div class="show-more-container" *ngIf="allEvents != undefined && displayCount < displayEvents.length">
        <button class="uoa-icon-btn btn-dark-blue-inverse">
          <div (click)="showMoreEvents()">
            <p class="uoa-btn-text">{{isMobile() ? 'View All' : 'Show More'}}</p>
            <ion-icon class="uoa-btn-icon" name="chevron-forward-outline"></ion-icon>
          </div>
        </button>
      </div>

      <div *ngIf="allEvents != undefined && displayEvents.length == 0">
        <p class="no-events">No Events Found</p>
      </div>
    </section>
  </div>
  <div class="footer">
    <app-footer></app-footer>
  </div>
</ion-content>
